import React, { useMemo, useState } from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { ColumnsType } from 'antd/es/table';
import EditCellTable from '@/components/EditCellTable';
import useInventoryPortal from '@/components/Inventory';
import FixStickyTable from '@/components/FixStickyTable';
import { getCheckRoomList, getOrderDetailBaseInfo } from '@/redux/actions/order';
import { IroomInfo } from '@/redux/reducers/order';
import {
  CheckStatus,
  CHECK_STATUS_MAP,
  CHECK_TYPE_MAP,
  COMPUTER_STATUS_MAP,
  DATE_TIME_FORMAT,
} from '@/config';
import { HistoryParams } from '@/utils/type';
import { renderIntlLabel } from '@/utils';
import { getTimeByUtcOffset } from '@/utils/intl';
import RoomTypeScroll from '../RoomTypeScroll';
import style from './index.module.scss';

const CheckRoom: React.FC<any> = ({
  checkRoomLogList,
  checkRoomList,
  checkRoomListLoading,
  getOrderDetailBaseInfoFn,
  fnGetCheckRoomList,
}) => {
  const { resvNo } = useParams<HistoryParams>();
  const [selectedItem, setSelectedItem] = useState<IroomInfo>();

  const inventoryPortal = useInventoryPortal();

  const dataSource = useMemo(() => {
    if (!selectedItem?.roomId) {
      return checkRoomLogList;
    }
    return checkRoomLogList.filter((item) => selectedItem?.roomId === item.roomId);
  }, [selectedItem, checkRoomLogList]);

  const onSelected = (_, item) => {
    setSelectedItem(item);
  };

  const handleCheckRoom = (record) => {
    const { id, status } = record;
    inventoryPortal.showDrawer({
      id,
      status,
      resvNo,
      callback: () => {
        getOrderDetailBaseInfoFn({ resvNo });
        fnGetCheckRoomList({ resvNo });
      },
    });
  };

  const columns: ColumnsType<any> = [
    {
      title: renderIntlLabel('order_detail_checkroom_room_no'),
      dataIndex: 'roomNo',
    },
    {
      title: renderIntlLabel('order_detail_enter_account_room_no'),
      dataIndex: 'billRoomNo',
    },
    {
      title: renderIntlLabel('order_detail_checkroom_type'),
      dataIndex: 'type',
      render: (val) => CHECK_TYPE_MAP[val],
    },
    {
      title: renderIntlLabel('order_detail_time_of_attack'),
      dataIndex: 'createTime',
      render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : '—'),
      width: 180,
    },
    {
      title: renderIntlLabel('order_detail_checkroom_time'),
      dataIndex: 'completeTime',
      render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : '-'),
      width: 180,
    },
    {
      title: renderIntlLabel('order_detail_computerStatus'),
      dataIndex: 'computerStatus',
      render: (val) => (val ? COMPUTER_STATUS_MAP[val] : '-'),
    },
    {
      title: renderIntlLabel('order_detail_checkroom_status'),
      dataIndex: 'status',
      render: (val) => CHECK_STATUS_MAP[val],
    },
    {
      title: renderIntlLabel('inventory_table_column_complete_name'),
      key: 'id',
      render: (record) => {
        return `${record.completeBy || ''} ${record.completeName || ''}`;
      },
    },
    {
      title: renderIntlLabel('order_action'),
      render: (_, record) => (
        <>
          {record.status === CheckStatus.HaveCheckRoom ? (
            <Button type="link" onClick={() => handleCheckRoom(record)}>
              {renderIntlLabel('order_action_checkroom_result')}
            </Button>
          ) : (
            <Button type="link" onClick={() => handleCheckRoom(record)}>
              {renderIntlLabel('order_action_checkroom')}
            </Button>
          )}
        </>
      ),
      fixed: 'right',
      align: 'right',
    },
  ];

  return (
    <div className={style.container}>
      <div className="space-between" style={{ alignItems: 'flex-start' }}>
        <div className="groupLabel">{renderIntlLabel('order_detail_checkroom_history')}</div>
      </div>
      <div className={style.guestContent}>
        <RoomTypeScroll type="checkRoom" list={checkRoomList} onSelected={onSelected} />
        {/*  右侧 */}
        <div>
          <FixStickyTable>
            <EditCellTable
              columns={columns}
              dataSource={dataSource}
              loading={checkRoomListLoading}
              pagination={false}
              scroll={{ x: 'max-content' }}
              sticky
            />
          </FixStickyTable>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.order,
  };
};

export default connect(mapStateToProps, {
  getOrderDetailBaseInfoFn: getOrderDetailBaseInfo,
  fnGetCheckRoomList: getCheckRoomList,
})(React.memo(CheckRoom));
